import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import ServicesLanding from "../views/ServicesLanding";
import ManagementConsulting from "../views/ManagementConsulting";
import ProcurementSupplyChain from "../views/ProcurementSupplyChain";
import FeasibilityEvaluations from "../views/FeasibilityEvaluations";
import ProjectProgrammeReviews from "../views/ProjectProgrammeReviews";
import InstitutionalCapacityDevelopment from "../views/InstitutionalCapacityDevelopment";
import MonitoringEvaluation from "../views/MonitoringEvaluation";
import LegalRegulatoryAdvisory from "../views/LegalRegulatoryAdvisory";
import OrganisationalChangeSupport from "../views/OrganisationalChangeSupport";
import PolicyFinancialAnalysis from "../views/PolicyFinancialAnalysis";
import MappingDevelopmentCooperation from "../views/MappingDevelopmentCooperation";


export default function Services(props) {

	const appContext = useContext(AppContext);

	const [ view, setView ] = useState(null);

	async function init() {
		//run initializations here
	}

	function getView() {
	if (
	!appContext.navSubItem &&
	!appContext.navExtraItem &&
	!appContext.navMoreItem
	) {
		return <ServicesLanding/>;
	}

	/* MANAGEMENT CONSULTING */
	else if (
		appContext.navSubItem === "management-consulting" &&
		!appContext.navExtraItem &&
		!appContext.navMoreItem
	) {
		return <ManagementConsulting/>;
	}

	/* PROCUREMENT & SUPPLY CHAIN */
	else if (
		appContext.navSubItem === "procurement-supply-chain" &&
		!appContext.navExtraItem &&
		!appContext.navMoreItem
	) {
		return <ProcurementSupplyChain/>;
	}

	/* FEASIBILITY STUDIES & EVALUATIONS */
	else if (
		appContext.navSubItem === "feasibility-evaluations" &&
		!appContext.navExtraItem &&
		!appContext.navMoreItem
	) {
		return <FeasibilityEvaluations/>;
	}

	/* PROJECT & PROGRAMME REVIEWS */
	else if (
		appContext.navSubItem === "project-programme-reviews" &&
		!appContext.navExtraItem &&
		!appContext.navMoreItem
	) {
		return <ProjectProgrammeReviews/>;
	}

	/* INSTITUTIONAL CAPACITY DEVELOPMENT */
	else if (
		appContext.navSubItem === "capacity-development" &&
		!appContext.navExtraItem &&
		!appContext.navMoreItem
	) {
		return <InstitutionalCapacityDevelopment/>;
	}

	/* MONITORING & EVALUATION */
	else if (
		appContext.navSubItem === "monitoring-evaluation" &&
		!appContext.navExtraItem &&
		!appContext.navMoreItem
	) {
		return <MonitoringEvaluation/>;
	}

	/* LEGAL & REGULATORY ADVISORY */
	else if (
		appContext.navSubItem === "legal-regulatory" &&
		!appContext.navExtraItem &&
		!appContext.navMoreItem
	) {
		return <LegalRegulatoryAdvisory/>;
	}

	/* ORGANISATIONAL CHANGE SUPPORT */
	else if (
		appContext.navSubItem === "organisational-change" &&
		!appContext.navExtraItem &&
		!appContext.navMoreItem
	) {
		return <OrganisationalChangeSupport/>;
	}

	/* POLICY & FINANCIAL ANALYSIS */
	else if (
		appContext.navSubItem === "policy-financial-analysis" &&
		!appContext.navExtraItem &&
		!appContext.navMoreItem
	) {
		return <PolicyFinancialAnalysis/>;
	}

	/* MAPPING STUDIES & DEVELOPMENT COOPERATION */
	else if (
		appContext.navSubItem === "mapping-development" &&
		!appContext.navExtraItem &&
		!appContext.navMoreItem
	) {
		return <MappingDevelopmentCooperation/>;
	}

	return null;
	}

	useEffect(() => {
		init();
	}, [ ])

	useEffect(() => {
		const _view = getView();
		if(_view) {
			setView(_view);
		}
	}, [ appContext.navSubItem, appContext.navExtraItem, appContext.navMoreItem ])

	//return desired view
	return view;
}